import React from 'react';
import { styled } from '../../../libs/styled.es.js';

const StyledToastContainer = styled.div `
  position: fixed;
  z-index: 100000;
  width: max-content;
`;
const TopLeft = styled(StyledToastContainer) `
  right: 1vw;
  top: 13vh;

  > :not(:last-child) {
    margin-bottom: 0.8rem;
  }
`;
const BottomCenter = styled(StyledToastContainer) `
  left: 50vw;
  transform: translateX(-50%);
  bottom: 12vh;
  display: flex;
  flex-direction: column-reverse;

  > :not(:last-child) {
    margin-top: 0.4rem;
  }
`;
const CenterCenter = styled(StyledToastContainer) `
  left: 50vw;
  top: 50vh;
  transform: translate(-50%, -50%);

  > :not(:last-child) {
    margin-bottom: 0.8rem;
  }
`;
const ToastContainer = ({ children, position = 'top-left', }) => {
    let Position = TopLeft;
    switch (position) {
        case 'top-left':
            Position = TopLeft;
            break;
        case 'bottom-center':
            Position = BottomCenter;
            break;
        case 'center-center':
            Position = CenterCenter;
    }
    return React.createElement(Position, null, children);
};

export { ToastContainer };
